import React from "react";
import { usePrograms } from "@/context/ProgramContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Radio } from "lucide-react";
import { DEFAULT_PROGRAM_LOGO } from "@/lib/brand";

const DEFAULT_LOGO = DEFAULT_PROGRAM_LOGO;

export default function ProgramSwitcher({ compact = false }) {
  const { programs, activeProgramId, setActiveProgramId, active } = usePrograms() || {};

  if (!programs || programs.length === 0) return null;

  // Single program → no switcher needed, show as badge
  if (programs.length === 1) {
    const p = programs[0];
    return (
      <div
        className="flex items-center gap-2 px-2 py-1 border border-zinc-200 rounded-sm"
        data-testid="program-badge-single"
      >
        <img
          src={p.logo_url || DEFAULT_LOGO}
          alt={p.name}
          className="h-6 w-auto"
        />
        {!compact && (
          <div className="leading-tight">
            <div className="text-[9px] uppercase tracking-[0.25em] font-bold text-zinc-500">
              Programa
            </div>
            <div className="font-heading text-sm font-bold tracking-tight">{p.name}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="program-switcher-btn"
          className="flex items-center gap-2 px-2 py-1 border border-zinc-200 rounded-sm hover:border-[#152D4B] transition"
        >
          <img
            src={active?.logo_url || DEFAULT_LOGO}
            alt={active?.name || "Programa"}
            className="h-6 w-auto"
          />
          {!compact && (
            <div className="leading-tight text-left">
              <div className="text-[9px] uppercase tracking-[0.25em] font-bold text-zinc-500">
                Programa
              </div>
              <div className="font-heading text-sm font-bold tracking-tight max-w-[180px] truncate">
                {active?.name || "Selecionar"}
              </div>
            </div>
          )}
          <ChevronDown className="w-3.5 h-3.5 text-zinc-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="rounded-sm w-64">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-[0.2em] flex items-center gap-1.5">
          <Radio className="w-3 h-3" /> Trocar de programa
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {programs.map((p) => (
          <DropdownMenuItem
            key={p.id}
            data-testid={`program-option-${p.id}`}
            onClick={() => {
              setActiveProgramId(p.id);
              // Full reload so lists re-fetch cleanly
              window.location.reload();
            }}
            className={`cursor-pointer ${p.id === activeProgramId ? "bg-zinc-50" : ""}`}
          >
            <img
              src={p.logo_url || DEFAULT_LOGO}
              alt={p.name}
              className="h-5 w-auto mr-2"
            />
            <span className="text-sm flex-1 truncate">{p.name}</span>
            {p.id === activeProgramId && (
              <span className="text-[9px] uppercase tracking-wider font-bold text-emerald-600 ml-2">ativo</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
